/* eslint-disable no-lonely-if */

import components from './_components';
import methods from './_methods';
import permissionUser from '@/inheritance/permission-user';



export default {
    /**
     * Nombre del componente
     */
    name: 'IssueViewDetails',

    extends: permissionUser,

    components,
    methods,

    /**
     * Props de entrada
     */
    props: {
        uuid: {
            type: String,
            required: false
        }
    },

    /**
     * @override
     */
    data() {
        return {
            issue: null,
            activeSectionFooter: null,
            collapsed: false,
            comment: null,
            resolved: false,
            asigneeType: [],
            valueUserGroup: '',
            modalResponsableShowed: false,
            filesArray: [],
            filenamesArray: [],
            uploading: false,
            timeline: [],
            files: [],
            loadingFiles: false,
            loadingComments: false,
            uuidIssue: null
        };
    },

    /**
     * @override
     */
    beforeMount() {
        this.prepareFetchData();
    },

    watch: {
        $route: {
            handler() {
                this.prepareFetchData();
            },
            immediate: true
        }
    },

    /**
     * Variables computadas
     */
    computed: {
        /**
         * Comprobamos el número de días hasta la expiración
         * @return {String} Número de días de diferencia
         */
        expirationTime() {
          const expirationDate = this.$moment(new Date(this.issue.expires_on), 'YYYY-MM-DD');
          const actualDate = this.$moment(new Date(), 'DD-MM-YYYY');
          return expirationDate.diff(actualDate, 'd');
        },

        /**
         * Obtenemos el mensaje de alerta de la issue
         * @return {String} message
         */
        getMessage() {

          const expirationTime = this.expirationTime;

          if (expirationTime === 1) {
            return "Esta incidencia está a punto de caducar";
          } else if (expirationTime > 1) {
            return `Faltan ${expirationTime} días para que esta incidencia caduque`;
          } else {
            const days = Math.abs(expirationTime);
            const daysString = days === 0 ? 'hoy' : `hace ${days} ${days === 1 ? 'día' : 'días'}`;
            return `Esta incidencia ha caducado ${daysString}`;
          }
        },

        /**
         * Obtenemos el tipo de objeto de la issue (cuenta/interviniente)
         * @return {String} Nombre del tipo
         */
        objectSelected() {
            if (this.issue.accounts || this.issue.interveners || this.issue.operations) {
                if (this.issue.accounts) {
                    return this.issue.accounts[0].id_object || this.issue.accounts[0].alias_account;
                } else if (this.issue.interveners) {
                    const intervener = this.issue.interveners[0];
                    const lastname2 = intervener.lastname_2 ? ` ${intervener.lastname_2}` : '';
                    let intervnerDisplay = `${intervener.lastname_1}${lastname2} ${intervener.name}`;
                    intervnerDisplay += intervener.document_id ? ` - ${intervener.document_id}` : '';
                    return intervnerDisplay;
                } else if (this.issue.operations) {
                    return this.issue.operations[0].id_object;
                }
            } else {
                return '';
            }
        },

        /**
         * Obtenemos a quién está asignada la issue (usuario/grupo)
         * @return {String} Nombre del responsable
         */
        userGroupSelected() {
            return `${this.$issuesService.getUserGroupSelected(this.issue)}`;
        }
    }
};
